/**
 * @generated SignedSource<<9cc38081a787a99178852d1540e9e793>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Fund_fund$data = {
  readonly category: string | null | undefined;
  readonly currency: string | null | undefined;
  readonly distribution: string | null | undefined;
  readonly fundsname: string | null | undefined;
  readonly largeinvestmentfonds: number | null | undefined;
  readonly traits: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly tranches: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly currency: string | null | undefined;
        readonly distribution: string | null | undefined;
        readonly id: string;
        readonly institutional: string | null | undefined;
        readonly isin: string | null | undefined;
        readonly salesadmission: ReadonlyArray<string | null | undefined> | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "Fund_fund";
};
export type Fund_fund$key = {
  readonly " $data"?: Fund_fund$data;
  readonly " $fragmentSpreads": FragmentRefs<"Fund_fund">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distribution",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Fund_fund",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fundsname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largeinvestmentfonds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "traits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "TrancheConnection",
      "kind": "LinkedField",
      "name": "tranches",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TrancheEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Tranche",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isin",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "institutional",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "salesadmission",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tranches(first:1000)"
    }
  ],
  "type": "Funds",
  "abstractKey": null
};
})();

(node as any).hash = "5ccf05c58487e817386d32c003cd5c04";

export default node;
